import { Alert, Box, Grid, MenuItem, Typography } from '@mui/material';
import React, { Dispatch } from 'react';
import { countries } from '../../../../../constants';
import { ISignatureCertificationRelationshipData } from '../../../../../Interfaces/ILegalTransactionRelationship/Relationships/SignatureCertification/ILegalTransactionRelationshipSignatureCertificationData';
import { CustomeTextField } from '../../../../generic/CustomeTextField';
import { NavRow } from '../../generic/NavRow';

interface ISignatureCertificationEditLanguageProps {
  scObject: ISignatureCertificationRelationshipData;
  setScObject: Dispatch<
    React.SetStateAction<ISignatureCertificationRelationshipData>
  >;
  handleNext: () => void;
  handleBack: () => void;
}

export const SignatureCertificationEditLanguage: React.FC<
  ISignatureCertificationEditLanguageProps
> = ({ scObject, setScObject, handleNext, handleBack }) => {
  const onSubmit = () => {
    handleNext();
  };

  const disableNext =
    scObject.idCountryTextLanguage === null ||
    scObject.idCountryUseOfText === null;

  return (
    <Box>
      <Box sx={{ mt: 5 }} />
      <Typography variant='h4'>Verwendung</Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Alert severity='info'>
            Ist die Vertragssprache eine andere als Deutsch?
          </Alert>
        </Grid>
        <Grid item xs={12}>
          <CustomeTextField // TODO: get rid of this
            attr='idCountryTextLanguage'
            label='Sprache des Textes'
            object={scObject}
            setObject={(upObj: ISignatureCertificationRelationshipData) =>
              setScObject({
                ...upObj,
                idCountryTextLanguage: upObj.idCountryTextLanguage || 1, // Default to German
              })
            }
            type='select'
            required
            null
          >
            {countries
              .sort((a, b) => (a.Nationality < b.Nationality ? -1 : 1))
              .map(country => (
                <MenuItem
                  key={`lanuage-idcounrtry-${country.idCountry}`}
                  value={country.idCountry}
                >
                  {country.Nationality}
                </MenuItem>
              ))}
          </CustomeTextField>
        </Grid>
        <Grid item xs={12}>
          <CustomeTextField
            attr='idCountryUseOfText'
            label='Verwendung des Textes'
            object={scObject}
            setObject={(upObj: ISignatureCertificationRelationshipData) =>
              setScObject({
                ...upObj,
              })
            }
            type='select'
            required
            null
          >
            {countries
              .sort((a, b) => (a.Country < b.Country ? -1 : 1))
              .map(country => (
                <MenuItem
                  key={`lanuage-idcounrtry-${country.idCountry}`}
                  value={country.idCountry}
                >
                  {country.Country}
                </MenuItem>
              ))}
          </CustomeTextField>
        </Grid>
      </Grid>

      <NavRow
        handleBack={handleBack}
        handleNext={onSubmit}
        disableNext={disableNext}
      />
    </Box>
  );
};
